// material-ui
import {alpha, styled, Theme} from '@mui/material/styles';
import Box from '@mui/material/Box';

// third-party
import SimpleBar, {Props} from 'simplebar-react';
import {BrowserView, MobileView} from 'react-device-detect';
import {MUIStyledCommonProps} from '@mui/system';
import {ReactNode} from 'react';

// root style
const RootStyle = styled(BrowserView)({
    flexGrow: 1,
    height: '100%',
    overflow: 'hidden',
});

// scroll bar wrapper
const SimpleBarStyle = styled(SimpleBar)(({theme}) => ({
    maxHeight: '100%',
    '& .simplebar-scrollbar': {
        '&:before': {backgroundColor: alpha(theme.palette.secondary.main, 0.25)},
        '&.simplebar-visible:before': {opacity: 1},
    },
    '& .simplebar-track.simplebar-vertical': {width: 10},
    '& .simplebar-track.simplebar-horizontal .simplebar-scrollbar': {height: 6},
    '& .simplebar-mask': {zIndex: 'inherit'},
}));

// ==============================|| SIMPLE SCROLL BAR  ||============================== //

export const SimpleBarScroll = ({children, sx, ...other}: MUIStyledCommonProps<Theme> & Props) => {
    return (
        <>
            <RootStyle>
                <SimpleBarStyle clickOnTrack={false} sx={sx} {...other}>
                    {children as ReactNode}
                </SimpleBarStyle>
            </RootStyle>
            <MobileView>
                <Box sx={{overflowX: 'auto', ...sx}} {...other}>
                    {children as ReactNode}
                </Box>
            </MobileView>
        </>
    );
};

export default SimpleBarScroll;
